import {
  isAllowDashedSpecialCharacters,
  isAllowedDashedAmpersSpecialCharacters,
  isAlphanumericAllSpecialCharacters,
} from "../../../functions/validations";


import { GenericTable } from "../../utility/common/TransactionComponents/GenericTable";


export const errorstatus = (error, columns, type) => {
  let status = false
  columns.map((column) => {
    if (column.field === 'SFA' || column.field === 'Classifcation' || column.field === 'ANo' || column.field === 'FNo' || column.field === 'ChemicalAnalysis_TradeName') {


      if (error[`WPSD_${type}_${column.field}`] && error[`WPSD_${type}_${column.field}`].status) {
        status = true
      }
    }

  })
  return status
}

export const errormessage = (error, columns, type) => {
  let message = ""
  columns.map((column) => {
    if (column.field === 'SFA' || column.field === 'Classifcation' || column.field === 'ANo' || column.field === 'FNo' || column.field === 'ChemicalAnalysis_TradeName') {
      if (error[`WPSD_${type}_${column.field}`] && error[`WPSD_${type}_${column.field}`].message) {
        message = error[`WPSD_${type}_${column.field}`].message
      }
    }
  })

  return message

}

export const WPSFillerMetals = ({ detailObj, setdetailObj, disabled, readOnly, SfaActive, FnoActive,
  AnoActive, setError, handleChangedetailsarray, setIsEdited, setClassError, classError, setChemicalAnaError,
  chemicalAnaError,
  error,
}) => {
  const columns = [
    {
      header: '',
      field: 'blank',
      type: 'label',
      textalign: "left",
      width: "1px",
      className: "thead-color"
    },
    {
      header: 'Process',
      field: 'process',
      type: 'text',
      textalign: "center",
      width: "30px"
    },
    {
      header: 'SFA',
      field: 'SFA',
      type: 'dropdown',
      valueField: 'wld_code',
      labelField: 'wld_code',
      align: "left",
      width: "80px",
      textalign: "left"
    },
    {
      header: "Classification",
      field: 'Classification',
      type: 'ProcessInput',
      inputWidth: '350px',
      maxLength: 12,
      validator: isAllowDashedSpecialCharacters,
      className: "WpsInput",
      textalign: "left",
      width: "200px"
    },
    {
      header: "F.No.",
      field: 'FNo',
      type: 'dropdown',
      valueField: 'wld_code',
      labelField: 'wld_code',
      align: "left",
      textalign: "left",
      width: "100px"
    },
    {
      header: 'A.No.',
      field: 'ANo',
      type: 'dropdown',
      validator: isAlphanumericAllSpecialCharacters,
      valueField: 'wld_code',
      labelField: 'wld_code',
      className: "WpsInput",
      textalign: "left",
      width: "100px"
    },
    {
      header: 'Chemical Analysis or TradeName',
      field: 'ChemicalAnalysis_TradeName',
      type: 'ProcessInput',
      validator: isAllowedDashedAmpersSpecialCharacters,
      inputWidth: "350px",
      maxLength: 25,
      className: "WpsInput",
      textalign: "left",
      width: "380px"
    },
  ];

  const tableData =
  {
    rows: detailObj?.map((item, i) => ({
      blank: { value: '' },
      process: { value: 'GTAW' },
      SFA: { value: item.WPSD_FM_SFA, field: `WPSD_FM_SFA`, index: i, error: false },
      Classification: { value: item.WPSD_FM_Classification, field: `WPSD_FM_Classification`, error: error["WPSD_FM_Classification"], rowError: classError, index: i, setProcessError: setClassError, errorRightPosition: "1px" },
      FNo: { value: item.WPSD_FM_FNo, field: `WPSD_FM_FNo`, index: i, error: false },
      ANo: { value: item.WPSD_FM_Ano, field: `WPSD_FM_Ano`, index: i, error: false },
      ChemicalAnalysis_TradeName: { value: item.WPSD_FM_ChemicalAnalysis_TradeName, field: `WPSD_FM_ChemicalAnalysis_TradeName`, index: i, error: error["WPSD_FM_ChemicalAnalysis_TradeName"], rowError: chemicalAnaError, setProcessError: setChemicalAnaError, errorRightPosition: "1px" },
      hasError: item.error,
      errorMessage: item.errormessage
    })) || []
  };

  return (
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={readOnly}
      setData={setdetailObj}
      disableFields={disabled}
      setError={setError}
      DataObj={detailObj}
      dropdownData={{
        SFA: [SfaActive],
        FNo: [FnoActive],
        ANo: [AnoActive]
      }}
      setIsEdited={setIsEdited}
      handleChange={handleChangedetailsarray}
      ProcessTable={true}
    />
  );
};
